import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { logout, notifyAuthRequired } from '../api/client';

const navItems = [
  { to: '/dashboard', label: 'Dashboard', icon: '📊' },
  { to: '/manager', label: 'AI Fund Manager', icon: '🧠' },
  { to: '/strategy', label: 'Strategy Builder', icon: '🧪' },
  { to: '/research/strategies', label: 'Saved Strategies', icon: '📚' },
  { to: '/research/school', label: 'Trading School', icon: '🎓' },
  { to: '/research/exam', label: 'Exam', icon: '📝' },
  { to: '/sessions', label: 'Sessions', icon: '🔄' },
  { to: '/data/import', label: 'Data Import', icon: '📥' },
  { to: '/data/symbols', label: 'Symbols', icon: '📈' },
  { to: '/data/overview', label: 'Data Overview', icon: '🗄️' },
];

export function AdminLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close the mobile menu after navigating.
  useEffect(() => setMenuOpen(false), [location.pathname]);

  const signOut = async () => {
    await logout().catch(() => undefined);
    notifyAuthRequired();
  };

  return (
    <div className={`admin-layout ${menuOpen ? 'admin-layout--menu-open' : ''}`}>
      <aside className="sidebar">
        <div className="sidebar-header">
          <h1 className="sidebar-title">Trading Admin</h1>
          <button
            type="button"
            className="menu-toggle"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            aria-controls="sidebar-nav"
            onClick={() => setMenuOpen((o) => !o)}
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
        <nav id="sidebar-nav" className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `nav-link ${isActive ? 'nav-link--active' : ''}`
              }
            >
              <span className="nav-link-icon">{item.icon}</span>
              <span className="nav-link-label">{item.label}</span>
            </NavLink>
          ))}
          <button type="button" className="nav-link nav-link--button" onClick={signOut}>
            <span className="nav-link-icon">🚪</span>
            <span className="nav-link-label">Sign out</span>
          </button>
        </nav>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
